

































































import { Component, Vue, Prop } from 'vue-property-decorator';
import TitlePage from '@/components/Title.vue';
import TableBlock from '@/components/data/Table/Table.vue';
import FilterPreview from '@/components/filter/FilterPreview.vue';
import FilterDropDown from '@/components/filter/FilterDropDown.vue';
import AddIcon from '@/components/icons/Add.vue';
import ExportIcon from '@/components/icons/Export.vue';

import ListLayout from './ListLayout.vue';

import PageBaseModule from '@/store/page';
import FilterModal from '@/store/modals/filter';
import { FilterSettings } from '@/types/filter/filter';

import { TableInterface } from '@/types/page/table';

@Component({
    components: {
        ListLayout,
        TitlePage,
        FilterPreview,
        FilterDropDown,
        TableBlock,
        AddIcon,
        ExportIcon,
    },
})
export default class List extends Vue {
    @Prop({ required: true }) readonly repository!: Readonly<PageBaseModule>;
    @Prop({ required: false }) readonly filterSettings?: FilterSettings;
    @Prop({ default: false }) readonly hasExportButton!: boolean;
    @Prop({ default: true }) readonly hasCreateButton!: boolean;
    @Prop({ required: false, default: () => ([]) }) readonly errorRows!: number[];

    focusKey = '' as string;

    get settings() {
        return this.repository.pageSettings;
    }

    get totalItems() {
        return (this.repository.pageSettings.table as TableInterface).totalItems;
    }

    get isShow() {
        return FilterModal.modal.isShow;
    }

    closeFilter() {
        FilterModal.closeModal();
    }

    updateList() {
        this.$emit('updateList');
    }

    toggleFilter(_: any, key: string) {
        FilterModal.toggleModal();
        this.focusKey = key;
    }

    resetFilters() {
        this.$emit('resetFilters');
    }

    toAdd() {
        this.$emit('toAdd');
    }

    toExport() {
      this.$emit('toExport');
    }

    selectAmount(amount: number) {
        const action = this.settings.actionPageAmountItems;

        if (typeof action === 'string') {
            this.$store.dispatch(action, amount);
        }
    }

    actionTable(handler: any) {
        if (handler.action === 'sort') {
            this.repository.sort({ field: handler.field.field, sort: handler.field.sort });
        }
    }

    mounted() {
        this.repository.init();
    }
}
